<template>
  <DwellingTypeRadioField :choices="choices" v-on="$listeners" />
</template>

<script>
import DwellingTypeRadioField from 'chimera/all/components/form/fields/dwellingType/DwellingTypeRadioField'
import { Selectable } from 'chimera/all/components/models/Selectable'

export default {
  name: 'DwellingTypeRadioFormPart',

  components: {
    DwellingTypeRadioField,
  },

  /**
   * The comp drops "Bouwgrond" and "Anders". Labels and values match the shared
   * part so the lead payload is unchanged for the options that remain.
   *
   * @returns {object}
   */
  data() {
    return {
      choices: [
        new Selectable(
          this.$i18n.t('residentialBuilding'),
          this.$i18n.t('residentialBuilding'),
          this.$i18n.t('residentialBuilding'),
        ),
        new Selectable(
          this.$i18n.t('apartment'),
          this.$i18n.t('apartment'),
          this.$i18n.t('apartment'),
        ),
      ],
    }
  },
}
</script>

<i18n>
{
  "nl-NL": {
    "residentialBuilding": "Woonhuis",
    "apartment": "Appartement"
  }
}
</i18n>
